import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ManageStudyState } from "src/pages/ManageStudies/models/interfaces";

const initialState: ManageStudyState = {
	access_Type: "",
	isEditable: false,
	manageStudyDetails: {},
	insights_id: null,
	isEditedTrans: {
		fileId: "",
		isEdited: false,
	},
};

const manageStudySlice = createSlice({
	name: "manageStudy",
	initialState,
	reducers: {
		setManageStudyDetails(state, action: PayloadAction<any>) {
			state.manageStudyDetails = action.payload;
		},
		setInsightsId(state, action: PayloadAction<string>) {
			state.insights_id = action.payload;
		},
		setNewTranscriptData(state, action: PayloadAction<any[] | null | undefined>) {
			if (!state.manageStudyDetails.processed_elements) {
				state.manageStudyDetails.processed_elements = { transcripts: [] };
			}
			state.manageStudyDetails.processed_elements.transcripts = Array.isArray(action.payload) ? action.payload : [];
		},
		setNewReportData(state, action: PayloadAction<any[] | null | undefined>) {
			if (!state.manageStudyDetails.processed_elements) {
				state.manageStudyDetails.processed_elements = { reports: [] };
			}
			state.manageStudyDetails.processed_elements.reports = Array.isArray(action.payload) ? action.payload : [];
		},
		setNewMetadataData(state, action: PayloadAction<any[] | null | undefined>) {
			if (!state.manageStudyDetails.processed_elements) {
				state.manageStudyDetails.processed_elements = { metadata: [] };
			}
			state.manageStudyDetails.processed_elements.metadata = Array.isArray(action.payload) ? action.payload : [];
		},
		// Optimistically reflect the metadata edit-lock holder (e.g. after a 423 from
		// acquire) so the locked icon/state shows immediately. The ~10s study-detail
		// poll reconciles this with the authoritative backend value.
		setMetadataLockHolder(state, action: PayloadAction<any | null>) {
			const metadata = state.manageStudyDetails?.processed_elements?.metadata;
			if (Array.isArray(metadata) && metadata.length > 0) {
				metadata[0].edit_lock = { ...(metadata[0].edit_lock || {}), holder: action.payload };
			}
		},
		setNewNotesData(state, action: PayloadAction<any[] | null | undefined>) {
			if (!state.manageStudyDetails.processed_elements) {
				state.manageStudyDetails.processed_elements = { notes: [] };
			}
			state.manageStudyDetails.processed_elements.notes = Array.isArray(action.payload) ? action.payload : [];
		},
		setNewDiscussionGuideData(state, action: PayloadAction<any>) {
			if (action.payload && action.payload?.length > 0) {
				if (!state.manageStudyDetails.processed_elements) {
					state.manageStudyDetails.processed_elements = { discussion_guide: [] };
				}
				state.manageStudyDetails.processed_elements.discussion_guide = action.payload;
			} else {
				state.manageStudyDetails.processed_elements.discussion_guide = [];
			}
		},
		setRemoveDiscussionGuideData(state) {
			state.manageStudyDetails.processed_elements.discussion_guide = [];
		},
		setAccessType(state, action: PayloadAction<{ access_type: string }>) {
			const { access_type } = action.payload;
			state.access_Type = access_type;
		},
		setIsEditable(state, action: PayloadAction<{ isEditable: boolean }>) {
			const { isEditable } = action.payload;
			state.isEditable = isEditable;
		},
		setIsEdited(state, action: PayloadAction<{ file_id: string }>) {
			const { file_id } = action.payload;
			if (file_id) {
				state.isEditedTrans = {
					fileId: file_id,
					isEdited: true,
				};
			}
		},
	},
});

export const {
	setAccessType,
	setInsightsId,
	setIsEditable,
	setManageStudyDetails,
	setMetadataLockHolder,
	setNewDiscussionGuideData,
	setNewMetadataData,
	setNewNotesData,
	setNewReportData,
	setNewTranscriptData,
	setRemoveDiscussionGuideData,
	setIsEdited,
} = manageStudySlice.actions;

export default manageStudySlice.reducer;
